import React from "react";
import ReactDOM from "react-dom/client"; // Use createRoot from React 18
import { Provider } from "react-redux";
import store from "./Redux/store";
import Router from "./Router";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router />
    </Provider>
  </React.StrictMode>
);

